import {
  ITableTitle,
} from "apps/website/components/feature/Table/ColumnRowTable/ColumnRowTable";
import { BRANDS } from "apps/website/constants/brands";

const DEFAULT_KATKIN_TITLE:ITableTitle = {
  id: "KATKIN",
  name: BRANDS.KATKIN,
  subheading: "Cluck Recipe",
};
const TEST_KATKIN_TITLE:ITableTitle = {
  id: "KATKIN",
  name: BRANDS.KATKIN,
  subheading: "Cluck (Chicken) Recipe",
};

export const OTHER_BRANDS: ITableTitle[] = [
  { id: "LILYS_KITCHEN",
    name: BRANDS.LILYS_KITCHEN,
    subheading: "Smooth Chicken Pate",
  },
  { id: "GORMET",
    name: "Gourmet",
    subheading: "Mon Petit Intense With Chicken",
  },
  { id: "SHEBA",
    name: BRANDS.SHEBA,
    subheading: "Fresh & Fine Cat Pouches with Chicken in Jelly" },
  { id: "WHISKAS",
    name: BRANDS.WHISKAS,
    subheading: "Poultry Feasts in Jelly with Chicken",
  },
  { id: "FELIX",
    name: "Felix",
    subheading: "As Good As It Looks with Chicken in Jelly",
  },
];

export const brandTitles: ITableTitle[] = [
  DEFAULT_KATKIN_TITLE,
  ...OTHER_BRANDS,

];

export const brandTitlesLandingPageTest: ITableTitle[] = [
  TEST_KATKIN_TITLE,
  ...OTHER_BRANDS,
];

const ROW_VALUES: [boolean, boolean, boolean, boolean, boolean, boolean][] = [
  [ true, false, false, false, false, false ],
  [ true, false, false, false, false, false ],
  [ true, false, true, true, true, true ],
  [ true, false, false, false, false, false ],
  [ true, false, true, true, true, true ],
];

export const brandComparisonTableDataAlt = {
  titles: brandTitles,
  rows: [
    {
      title: "100% Human-quality meats",
      values: [ true, false, false, false, false, false ],
    },
    {
      title: "Gently cooked for digestion",
      values: [ true, false, false, false, false, false ],
    },
    {
      title: "So fresh it's frozen",
      values: [ true, false, false, false, false, false ],
    },
    {
      title: "Free from preservatives",
      values: [ true, true, false, false, false, false ],
    },
    {
      title: "Free from sterilisation",
      values: [ true, false, false, false, false, false ],
    },
    {
      title: "Cooked in own kitchen",
      values: [ true, false, true, true, true, true ],
    },
    {
      title: "Perfectly portioned",
      values: [ true, false, false, false, false, false ],
    },
    {
      title: "From less than £2 a day",
      values: [ true, false, false, false, true, true ],
    },
  ],
};

export const brandComparisonTableData = {
  titles: brandTitles,
  rows: [
    {
      title: "100% gently-cooked meat*",
      values: ROW_VALUES[0],
    },
    {
      title: "So fresh it's frozen",
      values: ROW_VALUES[1],
    },
    {
      title: "Cooked in own kitchen",
      values: ROW_VALUES[2],
    },
    {
      title: "Tailored portions for your cat",
      values: ROW_VALUES[3],
    },
    {
      title: "From less than £2 a day",
      values: ROW_VALUES[4],
    },
  ],
  footer: "<p>Data accurate as of June 2025. Brand names used for comparison only. Daily price calculations are based on brand recommended feeding guidelines.</p><p>Daily price calculations based on brand recommended feeding guidelines</p><p><sup>*</sup>All KatKin recipes are gently cooked at <100 degrees<p>",
};

export const brandComparisonTableDataLandingPageTest = {
  titles: brandTitlesLandingPageTest,
  rows: [
    {
      title: "100% human-quality meat",
      values: ROW_VALUES[0],
    },
    {
      title: "Free from grains + veg proteins",
      values: ROW_VALUES[1],
    },
    {
      title: "Cooked in own kitchen",
      values: ROW_VALUES[2],
    },
    {
      title: "Tailored portions for your cat",
      values: ROW_VALUES[3],
    },
    {
      title: "From less than £2 a day",
      values: ROW_VALUES[4],
    },
  ],
  footer: "Data accurate as of June 2025. Brand names used for comparison only. Daily price calculations are based on brand recommended feeding guidelines.",
};
